<div [ngClass]="ngClass">
  <span class="truncate">
    <ng-content></ng-content>
  </span>
  <button
    *ngIf="isRemovable"
    type="button"
    class="button-icon"
    (click)="handleClick()"
  >
    <app-icon class="icon">cancel</app-icon>
  </button>
</div>
